import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

function useTakeawayValidationSchema() {
    const { t } = useTranslation('validationsSchema');

    const hourRegex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

    const daySchema = yup.object().test(
        'open-close-or-empty',
        t('scheduleInvalidRange'),
        function (value) {
            if (!value || Object.keys(value).length === 0) return true;
        
            const { open, close } = value;
            const hourRegex = /^\d{2}:\d{2}$/;
        
            const isOpenValid = typeof open === 'string' && hourRegex.test(open);
            const isCloseValid = typeof close === 'string' && hourRegex.test(close);
            if (!isOpenValid || !isCloseValid) return false;
        
            const toMinutes = (timeStr) => {
                const [h, m] = timeStr.split(':').map(Number);
                return h * 60 + m;
            };
        
            return toMinutes(close) > toMinutes(open);
        }
    );
      

    const schema = yup
        .object({
            coverUrl: yup
                .string()
                .required(t('imageUrlCannotBeEmpty'))
                .test('url-validation', t('invalidImageUrl'), (value) => {
                    if (!value) return false;
                
                    if (value.startsWith('blob:')) return true;
            
                    const urlRegex = /^https:\/\/firebasestorage\.googleapis\.com\/v0\/b\/[a-z0-9\-]+\.appspot\.com\/o\/[^\s?]+(\?alt=media(&token=[a-z0-9\-]+)?)?$/;
                    return urlRegex.test(value);
                }),

            description: yup
                .string()
                .required(t('descriptionCannotBeEmpty')),  

            location: yup
                .object({
                    latitude: yup
                        .number()
                        .required(t('locationLatitudeRequired')),  
                    longitude: yup
                        .number()
                        .required(t('locationLongitudeRequired')),  
                    address: yup
                        .string()
                        .required(t('locationAddressRequired'))  
                })
                .required(t('locationRequired')),

            schedule: yup
                .object({
                    monday: daySchema.required(),
                    tuesday: daySchema.required(),
                    wednesday: daySchema.required(),
                    thursday: daySchema.required(),
                    friday: daySchema.required(),
                    saturday: daySchema.required(),
                    sunday: daySchema.required(),
                })
                .required(t('scheduleRequired')),

            sellerPaysFees: yup
                .boolean()
                .required(t('sellerPaysFeesRequired')),

            takeawayOpen: yup
                .boolean()
                .required(t('takeawayOpenRequired')),
        })

    return schema;
}

export default useTakeawayValidationSchema;
